/**
 * <s-faq-search> — filters a list of FAQ <details> as the buyer types.
 *
 * Matches against each question and answer, case-insensitively. Shows the
 * [data-faq-empty] message when nothing matches. Without JavaScript the full
 * list stays visible.
 */
class SFaqSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.items = Array.from(this.querySelectorAll('[data-faq-list] > details'));
    this.empty = this.querySelector('[data-faq-empty]');
    if (!this.input) return;
    this.onInput = () => this.filter();
    this.input.addEventListener('input', this.onInput);
  }

  disconnectedCallback() {
    this.input?.removeEventListener('input', this.onInput);
  }

  filter() {
    const query = this.input.value.trim().toLowerCase();
    let visible = 0;
    for (const item of this.items) {
      const match = !query || item.textContent.toLowerCase().includes(query);
      item.hidden = !match;
      if (match) visible += 1;
    }
    if (this.empty) this.empty.hidden = visible > 0;
  }
}

if (!customElements.get('s-faq-search')) {
  customElements.define('s-faq-search', SFaqSearch);
}
